type BreadcrumbSchemaProp = {
  to: string;
  label: string;
  schemaTo: string;
};

type ItemListSchema = {
  '@type': 'ListItem';
  position: number;
  name: string;
  item?: string | null;
};

type BreadcrumbSchema = {
  '@context': string;
  '@type': string;
  itemListElement: ItemListSchema[];
};

const getItemsObj = (items: BreadcrumbSchemaProp[]): ItemListSchema[] =>
  items.map((item, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    name: item.label,
    ...(item.schemaTo ? { item: item.schemaTo } : null),
  }));

const getSEOSchema = (items: BreadcrumbSchemaProp[], currentItem: string): BreadcrumbSchema => {
  const formatedItemList = getItemsObj(items);
  return {
    '@context': 'https://schema.org/',
    '@type': 'BreadcrumbList',
    itemListElement: [
      ...formatedItemList,
      {
        '@type': 'ListItem',
        position: formatedItemList.length + 1,
        name: currentItem,
      },
    ],
  };
};

export default getSEOSchema;
